export const NEW_SLIDER_REQUEST = 'NEW_SLIDER_REQUEST'
export const NEW_SLIDER_SUCCESS = 'NEW_SLIDER_SUCCESS'
export const NEW_SLIDER_FAIL = 'NEW_SLIDER_FAIL'

export const GET_SLIDER_REQUEST = 'GET_SLIDER_REQUEST'
export const GET_SLIDER_SUCCESS = 'GET_SLIDER_SUCCESS'
export const GET_SLIDER_FAIL = 'GET_SLIDER_FAIL'

export const CLEAR_ERRORS = 'CLEAR_ERRORS'